import { $, Div, Link, Ref, Span } from '@tblabs/truffle';
import { appendable } from '@tblabs/truffle/Core/appendable';


export class Page extends Div
{
    protected header = new Div("page-header uk-background-primary");
    protected body = new Div("body");
    protected footer = new Div("page-footer uk-background-secondary")
        .Append(
            new Span("Powered by ").DisplayInlineBlock().MarginTop(3).Color("#999").Style("font-size: small;"),
            new Link("specTeam.pl", "https://www.specteam.pl").MarginLeft(4)
        );

    constructor(protected pageTitle: string | Ref<string>)
    {
        super("page");

        if (pageTitle instanceof Ref)
        {
            pageTitle.OnChange(v => document.title = v, true);
        }
        else
        {
            document.title = pageTitle;
        }

        this.Append(
            new Div("content").Append(
                new Div("content-inside").Append(
                    this.header,
                    this.body
                )
            ),
            this.footer
        );
    }

    protected AddToHeader(...components: appendable[]): this
    {
        this.header.Append(...components);
        return this;
    }

    protected AddToBody(...components: appendable[]): this
    {
        this.body.Append(...components);
        return this;
    }

    protected SetFooter(...components: appendable[]): this
    {
        this.footer
            .Clear()
            .Append(...components);

        return this;
    }
}
